import { TextField, TextFieldProps } from '@mui/material'
import React, { FC } from 'react'

export type BaseInputProps = TextFieldProps

const Input: FC<BaseInputProps> = (props) => {
  const {
    select,
    id,
    value,
    required,
    name,
    label,
    defaultValue,
    InputProps,
    inputProps,
    InputLabelProps,
    helperText,
    onChange,
    disabled = false,
    variant = 'outlined',
    margin = 'dense',
    autoComplete,
    error,
    children,
    hidden,
    size = 'small',
    sx = {},
    SelectProps,
  } = props
  const labelProps =
    disabled || defaultValue
      ? { ...InputLabelProps, shrink: true }
      : { ...InputLabelProps }
  const styling = () => {
    if (hidden) {
      return { display: 'none' }
    }
  }
  return (
    <TextField
      select={select}
      id={id}
      value={disabled && defaultValue ? defaultValue : value}
      required={required}
      name={name}
      label={label}
      InputProps={InputProps}
      inputProps={inputProps}
      defaultValue={defaultValue}
      disabled={disabled}
      error={error}
      margin={margin}
      helperText={helperText}
      autoComplete={autoComplete}
      InputLabelProps={labelProps}
      onChange={onChange}
      fullWidth
      size={size}
      variant={variant}
      sx={sx}
      SelectProps={SelectProps}
      style={styling()}
    >
      {children}
    </TextField>
  )
}

export default Input
